import { Expose, Type } from 'class-transformer';
import { KeyValueRecord } from '../../../shared/functions/record-functions';
import { FileNameModel } from '../file/file-name.model';

export class InvoiceDocumentOverviewModel {
  @Expose()
  public id?: number | null = null;

  @Type(() => FileNameModel)
  public attachments: FileNameModel = null;

  @Expose({ name: 'creation_date' })
  public creationDate: Date | null = null;

  /** Server: "meta": [{ key, value }] e.g. project id, brutto, vat, netto, etc. */
  public meta?: KeyValueRecord[] = [];
}
